import React, { useContext, useReducer, useEffect, useState } from 'react';
import { Icon, Header, Button, Divider, Form, Input, Tab, Message, Grid } from 'semantic-ui-react';
import history from 'services/history';
import { GlobalContext } from 'globalContext';
import Flatpickr from 'react-flatpickr';
import InputMask from 'react-input-mask';
import 'flatpickr/dist/l10n/pt.js';
import 'flatpickr/dist/themes/material_blue.css';
import './Combustiveis.scss';
import PreviaPedidos from './PreviaPedidos';
import { paramsToSearchURL } from 'utils';

const initialFormValues = {
    unidade: '',
    combustivel: '0',
    status: 1,
    dtPedidoUn: '',
    dtPedidoPer: '',
    dtDescarregamentoUn: '',
    dtDescarregamentoPer: '',
    dtVencUn: '',
    dtVencPer: '',
    numeroNota: '',
    dtEmissaoNotaUni: '',
    dtEmissaoNotaPer: '',
    idPedido: '',
    idProcesso: '',
};

function formReducer(state, action) {
    if ('reset' in action) return initialFormValues;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload };
}

export default function Combustiveis(props) {
    const [globalState] = useContext(GlobalContext);
    const [form, setForm] = useReducer(formReducer, initialFormValues);
    const tiposCombustiveisOptions = [
        { key: 1, text: 'Todos', value: '0' },
        { key: 2, text: 'Diesel', value: '03' },
        { key: 3, text: 'Diesel Aditivado', value: '07' },
        { key: 4, text: 'Diesel S-10', value: '09' },
        { key: 5, text: 'Etanol', value: '01' },
        { key: 6, text: 'Gasolina', value: '02' },
        { key: 7, text: 'Gasolina Aditivada', value: '06' },
        { key: 8, text: 'Gnv', value: '04' },
        { key: 9, text: 'Oleo Granel', value: '08' },
        { key: 10, text: 'Querosene', value: '05' },
    ];
    const statusPedidoOptions = [
        { key: 1, text: 'Todos', value: 1 },
        { key: 2, text: 'Somente com Pendências', value: 2 },
        { key: 3, text: 'Pendente de Descarregamento', value: 3 },
        { key: 4, text: 'Pendente de Documentação', value: 4 },
        { key: 5, text: 'Pendente de Pagamento', value: 5 },
    ];
    const [empresas, setEmpresas] = useState([]);
    const [errorInput, setErrorInput] = useState(false);
    const [errorInputIds, setErrorInputIds] = useState(false);

    useEffect(() => {
        if (form.unidade !== '') {
            setErrorInput(false);
        }
    }, [form]);

    useEffect(() => {
        if (globalState.empresas !== null) {
            let aux = [
                {
                    _id: 0,
                    codDpnet: '00',
                    nomeEmpresa: 'Todas',
                    nomeSecundario: 'Todas',
                    cnpjPrincipal: '00',
                    estado: '',
                    ativo: 1,
                    tipoNF: 'NFCE',
                    tipo: 'POSTO',
                    codAS: 0,
                },
            ];
            let newArr = aux.concat(globalState.empresas);
            setEmpresas(newArr);
        }
    }, [globalState.empresas]);

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } });
    }

    function handleChange(event) {
        let name, value;
        [name, value] = [event.target.name, event.target.value];
        setForm({ payload: { [name]: value } });
    }

    function handleSubmit() {
        if (form.unidade === '') {
            setErrorInput(true);
            return;
        }
        history.push(`${props.path}/combustiveis/relatorio`);
    }

    const limpar = () => {
        setForm({ reset: true });
        setErrorInput(false);
        setErrorInputIds(false);
    };

    const handleSubmitID = () => {
        if (form.idPedido === '' && form.idProcesso === '') {
            setErrorInputIds(true);
        } else {
            let params = {};
            for (let param in form) {
                switch (param) {
                    case 'idPedido':
                        if (form[param]) {
                            params[param] = form[param];
                        }
                        break;
                    case 'idProcesso':
                        if (form[param]) {
                            params[param] = form[param];
                        }
                        break;
                    default:
                        if (form[param] || form[param] === '') {
                            params[param] = form[param];
                        }
                }
            }
            history.push(`${props.path}/combustiveis/relatorio?${paramsToSearchURL(params)}`);
        }
    };

    const panes = [
        {
            menuItem: 'Pedido',
            render: () => (
                <Tab.Pane>
                    <Form size="tiny">
                        <Form.Group widths="equal">
                            <Form.Select
                                disabled={form.unidade !== '' ? false : true}
                                selectOnBlur={false}
                                search
                                label="Combustível"
                                options={tiposCombustiveisOptions}
                                name="combustivel"
                                value={form.combustivel}
                                onChange={handleChangeSelect}
                            />
                            <Form.Select
                                disabled={form.unidade !== '' ? false : true}
                                selectOnBlur={false}
                                search
                                label="Status do Pedido"
                                options={statusPedidoOptions}
                                name="status"
                                value={form.status}
                                onChange={handleChangeSelect}
                            />
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <label>Data do Pedido</label>
                                <Input
                                    children={
                                        <InputMask
                                            mask="99/99/9999"
                                            placeholder="Data Única"
                                            value={form.dtPedidoUn}
                                            name="dtPedidoUn"
                                            onChange={handleChange}
                                        />
                                    }
                                />
                            </Form.Field>
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <label>Descarregamento</label>
                                <Input
                                    children={
                                        <InputMask
                                            mask="99/99/9999"
                                            placeholder="Data Única"
                                            value={form.dtDescarregamentoUn}
                                            name="dtDescarregamentoUn"
                                            onChange={handleChange}
                                        />
                                    }
                                />
                            </Form.Field>
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <label>Vencimento</label>
                                <Input
                                    children={
                                        <InputMask
                                            mask="99/99/9999"
                                            placeholder="Data Única"
                                            value={form.dtVencUn}
                                            name="dtVencUn"
                                            onChange={handleChange}
                                        />
                                    }
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <Flatpickr
                                    placeholder="Por período"
                                    options={{
                                        enableTime: false,
                                        locale: 'pt',
                                        dateFormat: 'd/m/Y',
                                        mode: 'range',
                                    }}
                                    value={form.dtPedidoPer}
                                    onChange={handleChange}
                                />
                            </Form.Field>
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <Flatpickr
                                    placeholder="Por período"
                                    options={{
                                        enableTime: false,
                                        locale: 'pt',
                                        dateFormat: 'd/m/Y',
                                        mode: 'range',
                                    }}
                                    value={form.dtDescarregamentoPer}
                                    onChange={handleChange}
                                />
                            </Form.Field>
                            <Form.Field disabled={form.unidade !== '' ? false : true}>
                                <Flatpickr
                                    placeholder="Por período"
                                    options={{
                                        enableTime: false,
                                        locale: 'pt',
                                        dateFormat: 'd/m/Y',
                                        mode: 'range',
                                    }}
                                    value={form.dtVencPer}
                                    onChange={handleChange}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Divider />
                        <Button
                            disabled={form.unidade !== '' ? false : true}
                            positive
                            floated="right"
                            onClick={() => handleSubmit()}
                        >
                            Buscar
                        </Button>
                        <Button
                            disabled={form.unidade !== '' ? false : true}
                            icon
                            floated="right"
                            onClick={() => limpar()}
                        >
                            <Icon name="trash" />
                        </Button>
                    </Form>
                </Tab.Pane>
            ),
        },
        {
            menuItem: 'Nota Fiscal',
            render: () => (
                <Tab.Pane>
                    <Form size="tiny">
                        <Form.Group>
                            <Form.Field width="5" disabled={form.unidade !== '' ? false : true}>
                                <label>Número da Nota: </label>
                                <Input
                                    children={
                                        <InputMask
                                            placeholder="Ex: 00945"
                                            value={form.numeroNota}
                                            name="numeroNota"
                                            onChange={handleChange}
                                        />
                                    }
                                />
                            </Form.Field>
                            <Form.Field width="5" disabled={form.unidade !== '' ? false : true}>
                                <label>Data de Emissão</label>
                                <Input
                                    children={
                                        <InputMask
                                            mask="99/99/9999"
                                            placeholder="Data Única"
                                            value={form.dtEmissaoNotaUni}
                                            name="dtEmissaoNotaUni"
                                            onChange={handleChange}
                                        />
                                    }
                                />
                            </Form.Field>
                            <Form.Field width="6" disabled={form.unidade !== '' ? false : true}>
                                <label>{'\u00A0'}</label>
                                <Flatpickr
                                    placeholder="Por período"
                                    options={{
                                        enableTime: false,
                                        locale: 'pt',
                                        dateFormat: 'd/m/Y',
                                        mode: 'range',
                                    }}
                                    value={form.dtEmissaoNotaPer}
                                    onChange={handleChange}
                                    name="dtEmissaoNotaPer"
                                />
                            </Form.Field>
                        </Form.Group>

                        <Button
                            positive
                            floated="right"
                            onClick={() => handleSubmit()}
                            disabled={form.unidade !== '' ? false : true}
                        >
                            Buscar
                        </Button>
                        <Button icon floated="right" disabled={form.unidade !== '' ? false : true}>
                            <Icon name="trash" />
                        </Button>
                    </Form>
                </Tab.Pane>
            ),
        },
    ];

    return (
        <div id="combustiveis-valid-fisco" className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col px-0">
                        <Header as="h3">
                            <Icon.Group size="big">
                                <Icon name="tint" className="primary-color" />
                            </Icon.Group>
                            <Header.Content className="primary-color">
                                Módulo de Combustíveis <Header.Subheader>Filtros</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>

                <Divider className="mt-2 mb-2 custom-divider darken" fitted />

                <div className="row mx-0 mb-2">
                    <div className="col px-0">
                        <Grid columns={2} relaxed="very">
                            <Grid.Column>
                                <Header color={form.unidade !== '' ? 'black' : 'grey'}>
                                    1º) Selecione um Unidade
                                </Header>
                                <Form size="small">
                                    <Form.Select
                                        error={errorInput}
                                        selectOnBlur={false}
                                        search
                                        placeholder="Selecionar"
                                        options={(empresas || [])
                                            .filter((x) => x.tipo === 'POSTO')
                                            .map((x) => ({
                                                key: x.codDpnet,
                                                value: x.codDpnet,
                                                text: x.codDpnet + ' - ' + x.nomeEmpresa,
                                            }))}
                                        name="unidade"
                                        value={form.unidade}
                                        onChange={handleChangeSelect}
                                    />
                                </Form>
                            </Grid.Column>
                            <Grid.Column>
                                <Header>Informe um ID</Header>
                                <Form size="small">
                                    <Form.Group>
                                        <Form.Input
                                            error={
                                                errorInputIds && form.idPedido === '' ? true : false
                                            }
                                            placeholder="Pedido"
                                            value={form.idPedido}
                                            name="idPedido"
                                            onChange={handleChange}
                                            width={7}
                                        />
                                        <Form.Input
                                            error={
                                                errorInputIds && form.idProcesso === ''
                                                    ? true
                                                    : false
                                            }
                                            value={form.idProcesso}
                                            name="idProcesso"
                                            placeholder="Processo Validfisco"
                                            onChange={handleChange}
                                            width={7}
                                        />
                                        <Button
                                            floated="right"
                                            type="submit"
                                            color="green"
                                            onClick={() => handleSubmitID()}
                                        >
                                            Buscar
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid>
                        <Divider vertical>OU</Divider>
                    </div>
                </div>

                <div className="row mx-0 mt-1">
                    <div className="col px-0 styleTab">
                        <Message
                            info={form.unidade !== '' ? true : false}
                            attached
                            header="2°) Selecione os filtros"
                            content={
                                <Tab
                                    className="mt-2 styleTab"
                                    menu={{ fluid: true, vertical: true, tabular: true }}
                                    panes={panes}
                                />
                            }
                        />
                    </div>
                </div>

                <PreviaPedidos />
            </div>
        </div>
    );
}
